// Converts math delimiters that remark-math doesn't recognize into $$-delimited math.
// remark-math supports $$ for both inline (within text) and display (on its own line) math.
// We intentionally do NOT enable single-$ math (singleDollarTextMath: false) because
// this is an MBA program and $100, $5M, etc. would be misinterpreted as math delimiters.
export const formatMathInMessage = (messageContent: string) => {
    // if we somehow get %%$ in a string, we need to add a 0 width space before we replace all %% with $$ below
    // otherwise we can end up in an opened and not closed math block and it seems to blow up formatting
    messageContent = messageContent.replace(/(%%)(\$)/g, `%%${'\u200b'}$`);
    messageContent = messageContent.replace(/%%/g, '$$$');

    // LLMs often output \(...\) for inline math and \[...\] for display math (standard LaTeX conventions).
    // Convert these to $$...$$ which remark-math recognizes.
    messageContent = messageContent.replace(/\\\((.+?)\\\)/g, '$$$$$1$$$$');
    messageContent = messageContent.replace(/\\\[(.+?)\\\]/gs, '$$$$$1$$$$');

    return messageContent;
};
